import {
    REQUEST_GLOSSARY,
    REQUEST_GLOSSARY_FULLFILED,
    ABORT_REQUEST_GLOSSARY,
    THROW_REQUEST_GLOSSARY_ERROR
} from "../types";

export const retrieve = (token) => {
    return { type: REQUEST_GLOSSARY, payload: token };
}

export const fullfiled = (data) => {
    return { type: REQUEST_GLOSSARY_FULLFILED, payload: data };
}

export const abort = () => {
    return { type: ABORT_REQUEST_GLOSSARY };
}

export const throwError = (err) => {
    return { type: THROW_REQUEST_GLOSSARY_ERROR, payload: err };
}





// WEBPACK FOOTER //
// ./src/actions/glossary-actions.js